module.exports = __webpack_public_path__ + "static/media/homelogo.c731c4ef.png";